import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/folderShared.svg';

import styles from './FolderSharedIcon.styles';

type FolderSharedIconProps = {
  className?: string;
};

const useStyles = makeStyles(styles, { name: 'FolderSharedIcon' });

export default function FolderSharedIcon({ className }: FolderSharedIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.icon, className)}>
      <Icon />
    </span>
  );
}
